export const variables = {
    // API_URL: "https://prod6-api.master-planner.net/api/",
    API_URL: "https://prod-api.master-planner.net/api/",
    // API_URL: "https://api-mtbdev.master-planner.net/api/",
    // API_URL: "https://localhost:7214/api/",
    PHOTO_URL: "Images"
}